export const CORPORATE_CONTACT_KEY = {
  MYCRMACTIVE: 'MyCRMActive',
};
